'use client';

import { c as _c } from "react/compiler-runtime";
import { useParseSearchParams } from '@repo/sdk/qs';
import { useEffect, useState } from 'react';
export const useTableSorting = t0 => {
  const $ = _c(8);
  const {
    data
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [sorting, setSorting] = useState(t1);
  const {
    parsedParams
  } = useParseSearchParams();
  let t2;
  if ($[1] !== data.length || $[2] !== parsedParams) {
    t2 = () => {
      if (data.length && parsedParams?.sort) {
        setSorting(Object.entries(parsedParams.sort).map(_temp));
      }
    };
    $[1] = data.length;
    $[2] = parsedParams;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== data) {
    t3 = [data];
    $[4] = data;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== sorting) {
    t4 = {
      setSorting,
      sorting
    };
    $[6] = sorting;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
function _temp(t0) {
  const [key, values] = t0;
  return {
    desc: values === "desc",
    id: key
  };
}